import React from "react";
import { useSelector } from "react-redux";
import { getElementById } from "../utils/styleUtils";

export const CustomButton = ({ instanceId, field, form, ...props }) => {
  const formBuilder = useSelector((state) => state.customFormBuilder);
  const element = getElementById(instanceId, formBuilder);

  if (!element) {
    return <div>Button element not found</div>;
  }

  const elementStyle = element.style || {};

  const handleButtonClick = (e) => {
    e.preventDefault();
    if (elementStyle.actionType === "submit" && form) {
      form.handleSubmit();
    } else if (elementStyle.actionType === "reset" && form) {
      form.resetForm();
    }
    // Custom action handling can be added here
  };

  const getButtonStyles = () => {
    // Modern button styles
    return {
      fontSize: elementStyle.fontSize || "0.875rem",
      padding: elementStyle.padding || "0.5rem 1rem",
      margin: `${elementStyle.marginTop || "0"} ${
        elementStyle.marginRight || "0"
      } ${elementStyle.marginBottom || "0"} ${elementStyle.marginLeft || "0"}`,
      borderRadius: elementStyle.borderRadius || "0.375rem",
      borderStyle: elementStyle.borderStyle || "solid",
      borderColor: elementStyle.borderColor || "#0d6efd",
      backgroundColor: elementStyle.backgroundColor || "#0d6efd",
      color: elementStyle.textColor || "#ffffff",
      width: elementStyle.width || "auto",
      height: elementStyle.height || "auto",
      fontWeight: elementStyle.fontWeight || "500",
      textTransform: elementStyle.textTransform || "none",
      letterSpacing: elementStyle.letterSpacing || "normal",
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      gap: "0.5rem",
      cursor: "pointer",
      transition: "all 0.15s ease-in-out",
      boxShadow: elementStyle.boxShadow || "none",
      position: "relative",
      overflow: "hidden",
    };
  };

  const getIconStyles = () => {
    return {
      fontSize: elementStyle.iconSize || "1rem",
    };
  };

  const buttonType = elementStyle.buttonType || "button";
  const icon = elementStyle.icon || "bi-send";
  const showIcon = elementStyle.showIcon !== false;
  const iconPosition = elementStyle.iconPosition || "left";
  const buttonText = elementStyle.buttonText || "Submit";

  return (
    <div
      style={{ width: "100%", textAlign: elementStyle.alignment || "center" }}
    >
      <button
        type={buttonType}
        className="btn"
        onClick={handleButtonClick}
        style={getButtonStyles()}
        disabled={elementStyle.disabled}
        {...props}
      >
        {showIcon && iconPosition === "left" && (
          <i className={`bi ${icon}`} style={getIconStyles()}></i>
        )}
        <span>{buttonText}</span>
        {showIcon && iconPosition === "right" && (
          <i className={`bi ${icon}`} style={getIconStyles()}></i>
        )}
      </button>
    </div>
  );
};
